import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DistributionType, PartnershipType } from "../../types/genericType";

const initialPartnershipState: PartnershipType = {
  name: "",
  description: "",
  isActive: true,
  apartment: "",
  address: "",
  city: "",
  state: "",
  zip: "",
  country: "United States",
  id: 0,
};

const distributions: DistributionType[] = [];

interface PartnershipsState {
  partnershipsData: PartnershipType[];
  selectedPartnership: PartnershipType;
  distributions: DistributionType[];
}

const initialState: PartnershipsState = {
  partnershipsData: [],
  selectedPartnership: initialPartnershipState,
  distributions: distributions,
};

export const partnershipsSlice = createSlice({
  name: "partnershipsState",
  initialState,
  reducers: {
    setPartnerships: (state, action: PayloadAction<PartnershipType[]>) => {
      state.partnershipsData = action.payload;
    },
    setSelectedPartnership: (state, action: PayloadAction<PartnershipType>) => {
      state.selectedPartnership = action.payload;
    },
    setDistributions: (state, action: PayloadAction<DistributionType[]>) => {
      state.distributions = action.payload;
    },
    removeDistribution: (state, action: PayloadAction<number>) => {
      state.distributions = state.distributions.filter(
        (distribution) => distribution.id !== action.payload
      );
    },
    resetSelectedPartnership: (state) => {
      state.selectedPartnership = initialPartnershipState;
    },
  },
});

export const {
  setPartnerships,
  setSelectedPartnership,
  setDistributions,
  removeDistribution,
  resetSelectedPartnership,
} = partnershipsSlice.actions;

export default partnershipsSlice.reducer;
